import React from "react"
import { useArtImages } from "shared/Hooks/Biography"
import { useBiographyImages } from "shared/Hooks/Biography"
import Image from "gatsby-image"
import { ContentParagraph } from "components/Typography"

export const useTimelineData = () => {
  const imgs = useArtImages()
  const imgsBio = useBiographyImages()
  const data = {
    art: [
      {
        title: "1939-1949",
        heading: "1939 1939 1939 1939 1939",
        subheading: "1949 1949 1949 1949 1949",
        heroPhotos: {
          first: <Image fluid={imgs._1939_001.childImageSharp.fluid} />,
          second: <Image fluid={imgs._1939_004.childImageSharp.fluid} />,
          third: <Image fluid={imgs._1939_005.childImageSharp.fluid} />,
        },
        content: (
          <>
            <Image fluid={imgs._1939_003.childImageSharp.fluid} />
            <Image fluid={imgs._1939_002.childImageSharp.fluid} />
          </>
        ),
      },
      {
        title: "1950-1969",
        heading: "1950 1950 1950 1950 1950",
        subheading: "1969 1969 1969 1969 1969",
        heroPhotos: {
          first: <Image fluid={imgs._1950_007.childImageSharp.fluid} />,
          second: <Image fluid={imgs._1950_012.childImageSharp.fluid} />,
          third: <Image fluid={imgs._1950_009.childImageSharp.fluid} />,
        },
        content: (
          <>
            <Image fluid={imgs._1950_001.childImageSharp.fluid} />
            <Image fluid={imgs._1950_002.childImageSharp.fluid} />
            <Image fluid={imgs._1950_003.childImageSharp.fluid} />
            <Image fluid={imgs._1950_004.childImageSharp.fluid} />
            <Image fluid={imgs._1950_005.childImageSharp.fluid} />
            <Image fluid={imgs._1950_006.childImageSharp.fluid} />
            <Image fluid={imgs._1950_008.childImageSharp.fluid} />
            <Image fluid={imgs._1950_010.childImageSharp.fluid} />
            <Image fluid={imgs._1950_011.childImageSharp.fluid} />
            <Image fluid={imgs._1950_013.childImageSharp.fluid} />
            <Image fluid={imgs._1950_014.childImageSharp.fluid} />
            <Image fluid={imgs._1950_015.childImageSharp.fluid} />
          </>
        ),
      },
      {
        title: "1970-1979",
        heading: "1970 1970 1970 1970 1970",
        subheading: "1979 1979 1979 1979 1979",
        heroPhotos: {
          first: <Image fluid={imgs._1970_001.childImageSharp.fluid} />,
          second: <Image fluid={imgs._1970_004.childImageSharp.fluid} />,
          third: <Image fluid={imgs._1970_008.childImageSharp.fluid} />,
        },
        content: (
          <>
            <Image fluid={imgs._1970_002.childImageSharp.fluid} />
            <Image fluid={imgs._1970_003.childImageSharp.fluid} />
            <Image fluid={imgs._1970_005.childImageSharp.fluid} />
            <Image fluid={imgs._1970_006.childImageSharp.fluid} />
            <Image fluid={imgs._1970_007.childImageSharp.fluid} />
          </>
        ),
      },
      {
        title: "1980-1989",
        heading: "1980 1980 1980 1980 1980",
        subheading: "1989 1989 1989 1989 1989",
        heroPhotos: {
          first: <Image fluid={imgs._1980_001.childImageSharp.fluid} />,
          second: <Image fluid={imgs._1980_002.childImageSharp.fluid} />,
          third: <Image fluid={imgs._1980_003.childImageSharp.fluid} />,
        },
        content: (
          <>
            <Image fluid={imgs._1980_004.childImageSharp.fluid} />
          </>
        ),
      },
      {
        title: "1990-1999",
        heading: "1990 1990 1990 1990 1990",
        subheading: "1999 1999 1999 1999 1999",
        heroPhotos: {
          first: <Image fluid={imgs._1989_004.childImageSharp.fluid} />,
          second: <Image fluid={imgs._1989_003.childImageSharp.fluid} />,
          third: <Image fluid={imgs._1989_006.childImageSharp.fluid} />,
        },
        content: (
          <>
            <Image fluid={imgs._1989_001.childImageSharp.fluid} />
            <Image fluid={imgs._1989_002.childImageSharp.fluid} />
            <Image fluid={imgs._1989_005.childImageSharp.fluid} />
            <Image fluid={imgs._1989_007.childImageSharp.fluid} />
            <Image fluid={imgs._1989_008.childImageSharp.fluid} />
          </>
        ),
      },
      {
        title: "2000-2005",
        heading: "2000 2000 2000 2000 2000",
        subheading: "2005 2005 2005 2005 2005",
        heroPhotos: {
          first: <Image fluid={imgs._1999_005.childImageSharp.fluid} />,
          second: <Image fluid={imgs._1999_012.childImageSharp.fluid} />,
          third: <Image fluid={imgs._1999_008.childImageSharp.fluid} />,
        },
        content: (
          <>
            <Image fluid={imgs._1999_001.childImageSharp.fluid} />
            <Image fluid={imgs._1999_002.childImageSharp.fluid} />
            <Image fluid={imgs._1999_003.childImageSharp.fluid} />
            <Image fluid={imgs._1999_004.childImageSharp.fluid} />
            <Image fluid={imgs._1999_006.childImageSharp.fluid} />
            <Image fluid={imgs._1999_007.childImageSharp.fluid} />
            <Image fluid={imgs._1999_009.childImageSharp.fluid} />
            <Image fluid={imgs._1999_010.childImageSharp.fluid} />
            <Image fluid={imgs._1999_011.childImageSharp.fluid} />
          </>
        ),
      },
    ],
    biography: [
      {
        title: "1939-1949",
        heading: "1939 1939 1939 1939 1939",
        subheading: "1949 1949 1949 1949 1949",
        heroPhotos: {
          first: <Image fluid={imgsBio._1949_001.childImageSharp.fluid} />,
          second: <Image fluid={imgsBio._1949_007.childImageSharp.fluid} />,
          third: <Image fluid={imgsBio._1949_008.childImageSharp.fluid} />,
        },
        content: (
          <ContentParagraph>
            Wojnę spędza kilkunastoletni Zdzisław w Sanoku kontynuując edukację
            w liceum handlowym a równocześnie przerabia pierwsze klasy
            gimnazjalne w tajnym nauczaniu. Wtedy też zaczyna się jego
            fascynacja muzyką klasyczną słuchaną ukrytego pod podłogą radia i
            płyt z fragmentami oper w języku rosyjskim. Uczy się również gry na
            fortepianie. W 1947 roku Beksiński zdaje maturę w klasie o profilu
            matematyczno-fizycznym gimnazjum męskiego w Sanoku i rozpoczyna
            studia architektoniczne na Politechnice Krakowskiej. „W Akademii
            Sztuk Pięknych nie studiowałem nigdy z wyjątkiem egzaminu wstępnego
            i przyjęcia na studia. Zdawałem w Krakowie na ASP i architekturę w
            oba miejsca dostałem się, więc raczej z woli ojca wybrałem
            architekturę, a ojciec obiecał mi że jeśli ja ją skończę to opłaci
            mi studia w szkole filmowej i zostanę reżyserem, o czym marzyłem. Na
            architekturze uczyłem się rysunku i nigdy nie osiągnąłem z tego
            przedmiotu więcej niż dostatecznie z plusem. Mieliśmy 12 godzin na
            akt. Robiłem to w 3 kwadranse a potem leciałem do kina. Malarstwa
            nigdy nie studiowałem, zresztą do historii sztuki też się nie
            przykładałem”.
          </ContentParagraph>
        ),
      },
      {
        title: "1950-1969",
        heading: "1950 1950 1950 1950 1950",
        subheading: "1969 1969 1969 1969 1969",
        heroPhotos: {
          first: <Image fluid={imgsBio._1969_003.childImageSharp.fluid} />,
          second: <Image fluid={imgsBio._1969_008.childImageSharp.fluid} />,
          third: <Image fluid={imgsBio._1969_010.childImageSharp.fluid} />,
        },
        content: (
          <>
            <ContentParagraph>1951r. - Beksiński żeni się z Zofią Stankiewicz.</ContentParagraph>
            <ContentParagraph>1952r. - Po uzyskaniu dyplomu pracuje w budownictwie.</ContentParagraph>
            <ContentParagraph>
              Niestety kiedy skończyłem architekturę były nakazy pracy, ojciec
              umarł, musiałem zarabiać a socrealizm sprawił, że straciłem smak
              do zajmowania się filmem. Nie było warto ich robić[…] Zacząłem
              wtedy rysować. Praca artystyczna dawała mi chyba możliwość
              ucieczki od rzeczywistości. Pozwalała kreować własny świat,
              niezależny od tego, w którym organizowałem trójki murarskie i
              bicie rekordów[…] Początkowo utrzymywała mnie matka i żona potem
              to się zmieniło.
            </ContentParagraph>
            <ContentParagraph>
              1955r. - powrót do Sanoka, gdzie Beksiński mieszka w domu
              rodzinnym ul ul Świerczewskiego. W drugiej połowie lat 50-tych
              Beksiński kojarzony jest głównie z fotografią. Zostaje członkiem
              związku polskich artystów fotografików i wystawia swoje prace
              prowokując bardzo rozbieżne opinie krytyki. Równocześnie powstają
              jego pastele - bardzo ekspresjonistyczne, pełne zdeformowanych,
              półabstrakcyjnych ludzkich postaci, w których sylwetki często
              wkomponowano mechaniczne elementy.
            </ContentParagraph>
            <ContentParagraph>
              1958r. - Beksińskim rodzi się syn Tomasz. Na przełomie lat 50-tych
              i 60-tych powstają abstrakcyjne reliefy, wykonane ze sztucznych
              tworzyw, blachy i drutu oraz gipsowe rzeźby i płaskorzeźby.
            </ContentParagraph>
            <ContentParagraph>1960r. - Beksiński zarzuca fotografię.</ContentParagraph>
            <ContentParagraph>
              1964r. - maj/czerwiec pierwsza zorganizowana przez Janusza
              Boguckiego duża wystawa (31 obrazów, 22 rzeźby, 33 heliografie i
              aż 116 rysunków). Stara Pomarańczarnia w warszawskich Łazienkach.
              Krytycy podkreślają bogactwo form, wyobraźnię i ekspresyjność jego
              sztuki choć nie brak też głosów krytycznych.
            </ContentParagraph>
          </>
        ),
      },
      {
        title: "1970-1979",
        heading: "1970 1970 1970 1970 1970",
        subheading: "1979 1979 1979 1979 1979",
        heroPhotos: {
          first: <Image fluid={imgsBio._1979_001.childImageSharp.fluid} />,
          second: <Image fluid={imgsBio._1979_002.childImageSharp.fluid} />,
          third: <Image fluid={imgsBio._1979_004.childImageSharp.fluid} />,
        },
        content: (
          <>
            <ContentParagraph>
              Na początku lat 70-tych w twórczości Beksińskiego zaczyna
              dominować malarstwo. Stopniowo zmienia się tematyka. Od 1972r
              wyraźnie mniej jest czaszek, upiorów, rozkładających się ciał, a
              pojawiają się wielkie nastrojowe pejzaże pełne tajemniczych
              budowli i ruin porośniętych pajęczyną i trawą. Krytycy piszą o
              persyflażu, zabawach ze stylami zwłaszcza XIX-wiecznym malarstwem
              romantycznym i XX wiecznym surrealizmem.
            </ContentParagraph>
            <ContentParagraph>
              1972r. - Grudzień , indywidualna wystawa, Galeria Współczesna w
              Warszawie. Zdecydowałem się na niskie ceny i sprzedałem wszystkie
              wystawione obrazy. To było malarstwo fantastyczne, publiczność
              odbierała je z nieco innej strony niż sobie zamarzyłem. Ale tak
              się zaczęła nasza symbioza. Przez środowisko krytyków jest już
              traktowany jako prawdziwy choć nadal bardzo kontrowersyjny
              artysta.
            </ContentParagraph>
            <ContentParagraph>
              1974r. - Beksińskiemu przyznano nagrodę państwową. Powstają
              ostatnie rysunki. Formą i treścią są identyczne z malarstwem
              wykonane sprasowanym węglem na stosunkowo dużych formatach
              100x70cm
            </ContentParagraph>
            <ContentParagraph>
              1975. - Galeria Zachęta w Warszawie -w ankiecie AICA
              (Międzynarodowego Stowarzyszenia Krytyków Sztuki) 30 arcydzieł na
              XXX-lecie rozpisanej wśród polskich krytyków, nazwisko
              Beksińskiego pojawia się na pierwszym miejscu
            </ContentParagraph>
            <ContentParagraph>
              1977r. - rodzinny dom artysty w Sanoku przeznaczono do wyburzenia
              co przyspiesza decyzję Beksińskiego o przeniesieniu się do
              Warszawy. „Lubię się zgubić w tłumie bo wtedy się nie wyróżniam i
              czuję się dobrze. Najchętniej mieszkałbym w Hamburgu albo w Nowym
              Yorku w takim gotującym się piekielnym kotle, monstrualnym
              skupisku ludzi. Dla mnie jako miłośnika sztuczności,
              nienawidzącego dźwięków psów, małych dzieci, ptaków, większość
              dźwięków jakie wydaje Warszawa a więc samochody, tramwaje,
              samoloty to dźwięki w zasadzie obojętne a nawet miłe dla ucha
              jeśli porówna się je z ciszą idealną”
            </ContentParagraph>
            <ContentParagraph>
              1979r. - indywidualna wystawa Galeria Kartstadt-Haus w Kolonii
            </ContentParagraph>
          </>
        ),
      },
      {
        title: "1980-1989",
        heading: "1980 1980 1980 1980 1980",
        subheading: "1989 1989 1989 1989 1989",
        heroPhotos: {
          first: <Image fluid={imgsBio._1989_002.childImageSharp.fluid} />,
          second: <Image fluid={imgsBio._1989_001.childImageSharp.fluid} />,
          third: <Image fluid={imgsBio._1989_003.childImageSharp.fluid} />,
        },
        content: (
          <>
            <ContentParagraph>
              1981r. - Lipiec/wrzesień, indywidualna wystawa Galeria Wahl w
              Warszawie
            </ContentParagraph>
            <ContentParagraph>
              1982r. - Trwa Stan Wojenny - prace Beksińskiego są często
              odbierane jako wyraz ówczesnej sytuacji kraju. Sam artysta
              skomentuje to w 1984r „Jestem chyba dość niewrażliwy na
              rzeczywistość polityczną. Może dlatego, że żyję na uboczu, nie
              pracuję w instytucji, nie muszę chodzić na nasiadówki, nie
              wytwarza się we mnie ta gigantyczna niechęć do systemu, która
              nawarstwiła się u 90% moich znajomych. Jestem po prostu obojętny.
              Około połowy 80 lat malarstwo artysty zaczyna ewoluować w kierunku
              ascetyzmu tematu i formy czemu towarzyszy wyostrzenie stosowanych
              środków. Dominują barwy stonowane, gamy monochromatyczne, chłodne
              szarości. Jakby zmęczony pretensjami o przerost treści zaczął
              malować niemal wyłącznie formę. Sam twórca wspomina, że ostatnią
              serię obrazów "w starym stylu" namalował wyłącznie na prośbę
              Dmochowskiego.
            </ContentParagraph>
            <ContentParagraph>
              1985r. - Październik, indywidualna wystawa (ok.15 tyś widzów)
              obrazów i rysunków ze zbiorów Dmochowskiego w Galerii Valmay w
              Paryżu
            </ContentParagraph>
            <ContentParagraph>
              1986r. - Kwiecień wystawa zbiorowa - Salon Niezależnych Grand
              Palais, Paryż
            </ContentParagraph>
            <ContentParagraph>
              1987r. - Kwiecień - wystawa Muzeum Historyczne w Rzeszowie (18 tyś
              odwiedzających przez 6 tygodni) - Czerwiec - wystawa zbiorowa XXI
              International Award of Conterporari Art. O f Monte Carlo (UNESCO
              przyznaje Beksińskiemu nagrodę) - Grudzień - wystawa Galeria Wahl
              w Warszawie
            </ContentParagraph>
            <ContentParagraph>1988r. - Październik - wystawa Galeria BWA w Poznaniu</ContentParagraph>
            <ContentParagraph>1989r. - Październik/Listopad - galeria Dmochowski Paryż</ContentParagraph>
          </>
        ),
      },
      {
        title: "1990-1999",
        heading: "1990 1990 1990 1990 1990",
        subheading: "1999 1999 1999 1999 1999",
        heroPhotos: {
          first: <Image fluid={imgsBio._1999_001.childImageSharp.fluid} />,
          second: <Image fluid={imgsBio._1999_004.childImageSharp.fluid} />,
          third: <Image fluid={imgsBio._1999_005.childImageSharp.fluid} />,
        },
        content: (
          <>
            <ContentParagraph>
              1990r. - październik wystawa „Toh-Ou Museum” (Muzeum Europy
              Wschodniej) w Osace (Japonia) - listopad Galeria Nowoczesna
              Kołobrzeg - grudzień wystawa - galeria BWA w Słupsku.
            </ContentParagraph>
            <ContentParagraph>
              1993r. - wystawa „Od awangardy do postmodernizmu” - galeria BWA w
              Olsztynie.
            </ContentParagraph>
            <ContentParagraph>
              1994r. - luty - wystawa Galeria Sceny Plastycznej KUL w Lublinie
              „Wraz z wiekiem obniża się temperatura emocji powiedział artysta
              podczas konferencji prasowej, a mam już 65 lat dodał - zapytany o
              genezę twórczości, przekazywane treści, tragizm emanujący z
              obrazów - przypomniał, że jego malarstwo wyrasta z
              abstrakcjonizmu, a często powtarzane interpretacje doszukujące się
              źródeł dramatyzmu prac w tragedii wojny - nie mają uzasadnienia.
              Temu tematowi nie jest potrzebne malarstwo - wyjaśnił. Impulsem
              dla powstania obrazu jest zwykle impresja. Przychodzi mi pomysł do
              głowy - maluję. Na moim obrazie znacznie więcej jest rzeczy
              zamalowanych, niż tych które widać na wierzchu. Malowanie obrazu
              jest dla mnie przygodą przeżywaną z pędzlem w ręku przed kawałkiem
              płyty pilśniowej. Może jest to jakaś walka z przemijaniem.
            </ContentParagraph>
            <ContentParagraph>
              1995r. - retrospektywna wystawa w Muzeum Archidiecezji
              Warszawskiej. Malarstwo Beksińskiego z kolekcji Anny i Piotra
              Dmochowskich. Najnowsze prace różnią się nieco od tych, które
              mieliśmy okazję oglądać na wystawach dotychczas. Częściej pojawia
              się postać ludzka, głowa, barwy też coraz bardziej spokojnie.
              Zmieniłem swój styl malowania już przed 5-6-cioma laty. U mnie
              nigdy jednak zmiany nie zachodzą skokowo. Co najmniej dwa trzy
              lata trwa takie „cieniowanie” i nie rozstaję się ze starym
              sposobem malowania. Tym niemniej od dłuższego już czasu nie maluję
              „pejzaży metafizycznych” które stały się przed laty mają
              wizytówką. Znudziły mi się, jak wszystko co staje się monotonne.
              Gdy nawiązałem kontakt z Piotrem Dmochowskim uległem wprawdzie
              jego sugestii i na pierwszą paryską wystawę w 1985 roku wykonałem
              jeszcze kilkanaście odgrzewanych kotletów. Po czym robiłem już
              wyłącznie to co chcę. Zdaję sobie sprawę, że publiczność mniej to
              lubi ale ja zawsze myślałem tylko o zadowoleniu siebie.
            </ContentParagraph>
            <ContentParagraph>
              1996r. - styczeń/luty wystawa w BWA w Katowicach. Marzec /kwiecień
              wystawa Pałac Opatów w Gdańsku - Oliwie.
            </ContentParagraph>
            <ContentParagraph>
              1999r. - europejskie Stowarzyszenie SF (science-fiction) przyznaje
              Beksińskiemu jako grafikowi nagrodę Eurokon. Kwiecień/maj -
              pierwsza wystawa komputerowych fotomontaży - Galeria Sztuki
              Współczesnej w Gliwicach.
            </ContentParagraph>
            <ContentParagraph>24-12-1999 syn artysty Tomasz popełnia samobójstwo.</ContentParagraph>
          </>
        ),
      },
      {
        title: "2000-2005",
        heading: "2000 2000 2000 2000 2000",
        subheading: "2005 2005 2005 2005 2005",
        heroPhotos: {
          first: <Image fluid={imgsBio._2005_002.childImageSharp.fluid} />,
          second: <Image fluid={imgsBio._2005_008.childImageSharp.fluid} />,
          third: <Image fluid={imgsBio._2005_009.childImageSharp.fluid} />,
        },
        content: (
          <>
            <ContentParagraph>
              2001r - styczeń, wystawa, malarstwo, Galeria Lonty - Petry w
              Częstochowie - luty /marzec, wystawa obrazów, BWA w Rzeszowie
              organizator Fundacja Beksiński
            </ContentParagraph>
            <ContentParagraph>
              2002r - listopad 2001/styczeń 2002, wystawa, Fotografie z lat 1953
              - 1959 Muzeum Narodowe w Gdańsku - lipiec / wrzesień, wystawa,
              Fotografie z lat 1953 - 1959 Galeria Zachęta w Warszawie
            </ContentParagraph>
            <ContentParagraph>
              2003r - luty/marzec, wystawa prac z kolekcji Muzeum Historycznego
              w Sanoku, Miejska Galeria Sztuki w Częstochowie. -
              listopad/grudzień, wystawa z kolekcji Muzeum Historycznego w
              Sanoku, Muzeum Archeologiczno - Historyczne w Głogowie
            </ContentParagraph>
            <ContentParagraph>
              2004r - 16 prac Zdzisława Beksińskiego, pochodzących z paryskiej
              kolekcji Anny i Piotra Dmochowskich zostały przekazane Miejskiej
              Galerii Sztuki w Częstochowie do stałej ekspozycji. - marzec /
              kwiecień, "Multimedialne spotkanie z artystą", Muzeum Historii
              Miasta Łodzi. Prezentacja 27 obrazów olejnych, 17 fotomontaży i 10
              grafik modyfikowanych komputerowo. Dzięki tele - transmisji
              Beksiński uczestniczył w łódzkim wernisażu wystawy siedząc
              wygodnie w warszawskiej pracowni. Organizator Fundacja Beksiński.
            </ContentParagraph>
            <ContentParagraph>
              2005r - 21 lutego 2005 roku - tragiczna śmierć artysty na 3 dni
              przed 76 rocznicą urodzin.
            </ContentParagraph>
          </>
        ),
      },
    ],
  }

  return data
}
